import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { DefineSchema } from "@/app/schema/define-schema"; // Assuming this is where your schema is

interface DefineStore {
  defineData: DefineSchema | null;
  setDefineData: (data: DefineSchema) => void;
  deleteShippingMode: (index: number) => void; // New function to remove a specific shipping mode
  clearDefineData: () => void;
}

export const useDefineStore = create<DefineStore>()(
  persist(
    (set, get) => ({
      defineData: null, // Initial state

      // Set Define Data
      setDefineData: (data: DefineSchema) => set({ defineData: data }),

      // New function to remove a shipping mode by its index
      deleteShippingMode: (index: number) => {
        const { defineData } = get();

        if (defineData) {
          const updatedShippingModes = defineData.shippingModes.filter(
            (_, i) => _.mode !== index+1
          );

          set({
            defineData: {
              ...defineData,
              shippingModes: updatedShippingModes, // Update shipping modes after removal
            },
          });
        }
      },

      // Clear Define Data
      clearDefineData: () => set({ defineData: null }),
    }),
    {
      name: "define", // Key for localStorage/sessionStorage
      storage: createJSONStorage(() => sessionStorage), // Use sessionStorage for persistence
    }
  )
);
